export default {
  cursive: '"Finger Paint", cursive;',
  sansSerif: 'Avenir, sans-serif',
  serif: '"Playfair Display", Times New Roman, serif',
}
